import BasicLayout from 'src/components/BasicLayout';
import PdfComponent from 'src/components/PdfComponent';
import pdfData from 'assets/slides/2010-secol-worthy-of-attention-collostruction.pdf';
import * as React from 'react';
export default {
  BasicLayout,
  PdfComponent,
  pdfData,
  React
};